import script from "./UserArchiveReferral.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserArchiveReferral.vue?vue&type=script&setup=true&lang=ts"

import "./UserArchiveReferral.vue?vue&type=style&index=0&id=c10c9e54&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c10c9e54"]])

export default __exports__